import { render, staticRenderFns } from "./tronscanCollection.vue?vue&type=template&id=50a7c376&scoped=true"
import script from "./tronscanCollection.vue?vue&type=script&lang=js"
export * from "./tronscanCollection.vue?vue&type=script&lang=js"
import style0 from "./tronscanCollection.vue?vue&type=style&index=0&id=50a7c376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a7c376",
  null
  
)

export default component.exports